__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/b824064/_next/";